"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../../helpers/index.js");

var _index2 = require("../../utils/index.js");

var customPageName = function customPageName(event) {
  var eventPageName = event.xdm.web.webPageDetails._telus.pageName;
  var defaultPageName = (0, _index.getPageNameValues)().pageName;
  if (eventPageName === defaultPageName) return event;
  var siteSections = eventPageName.split('>').slice(1);
  var webPageDetails = {
    name: eventPageName,
    siteSection: siteSections[0],
    _telus: {
      customSiteSection: siteSections[0],
      primarySiteSection: siteSections[1],
      secondarySiteSection: siteSections[2],
      tertiarySiteSection: siteSections[3],
      quaternarySiteSection: siteSections[4]
    }
  };
  event.xdm.web.webPageDetails = (0, _index2.mergeObjects)(webPageDetails, event.xdm.web.webPageDetails);
  return event;
};

var _default = customPageName;
exports["default"] = _default;